import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: inline-flex;
  padding-top: 8px;
  width: 100%;
  height: 80px;

  > div {
    margin-left: 8px;
    h6 {
      margin-top: 8px;
      margin-bottom: 0;
      line-height: 1;
    }
    small {
      font-size: 0.7em;
    }
  }
`;

// TODO
// This is a temporary hack until we fully adopt the Neo theme across the app
// The logo component here is copied from Logo8x8.js in the oxygen-graphics package,
// with color modifications to match the new branding.
// When the Neo theme is fully adopted, using the Logo8x8 component,
// directly from the oxygen-graphics package, should be sufficient.
const Logo = ({ forwardedRef, ...rest }) => {
  // Colors from the newer oxygen-theme package (we are still using an older version, v2.19.0)
  const theme = { brand01: "#26252A", brand05: "#C6DC60" };
  // The logo as created in the version of oxygen-graphics we are using (v2.37.0), but with the colors replaced
  return (
    /* eslint-disable */
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
      {...rest}
    >
      <rect width="48" height="48" fill={theme.brand05} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5668 24.2033L16.5624 24.2087C17.568 24.8856 18.3308 25.8332 18.3308 27.2884C18.3308 29.522 16.4931 31.7218 12.8176 31.7218C9.21144 31.7218 7.30435 29.522 7.30435 27.2207C7.30435 25.3255 8.89937 24.0057 9.35014 23.6672C8.55263 22.9904 7.99784 22.1443 7.99784 20.8921C7.99784 18.7939 9.52351 16.7295 12.991 16.6956C15.7649 16.6956 18.0187 18.1847 18.0187 20.8921C18.0187 22.4336 16.7269 24.0082 16.5668 24.2033ZM12.9225 19.8428C13.8934 19.8428 14.4828 20.3843 14.4828 21.1965C14.4828 22.0764 14.1014 22.7532 13.9627 22.9901C12.6451 22.4487 11.5702 21.941 11.5702 20.9934C11.5702 20.3504 11.9863 19.8428 12.9225 19.8428ZM11.0153 26.8818C11.0153 27.8294 11.8128 28.5739 12.8184 28.5739C13.928 28.5739 14.5868 28.0663 14.5868 27.0848C14.5868 26.3361 13.467 25.8462 12.1511 25.2704C12.0398 25.2217 11.9264 25.1721 11.8128 25.122C11.4661 25.4942 11.0153 26.1034 11.0153 26.8818Z"
        fill={theme.brand01}
      />
      <path
        d="M25.1617 22.0093H28.7678L26.0286 26.3412L28.8372 30.7069H25.3004L24.3295 28.9132C24.2255 28.744 24.0868 28.4395 24.0868 28.4395H24.0521C24.0521 28.4395 23.9134 28.744 23.8094 28.9132L22.8385 30.7069H19.3017L22.1103 26.3412L19.267 22.0093H22.8732L23.6707 23.5323C23.8094 23.7692 23.9828 24.0399 23.9828 24.0399H24.0174C24.0174 24.0399 24.2255 23.7692 24.3295 23.5323L25.1617 22.0093Z"
        fill={theme.brand01}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.9273 24.2087L38.9317 24.2033C39.0917 24.0082 40.3836 22.4336 40.3836 20.8921C40.3836 18.1847 38.1298 16.6956 35.3558 16.6956C31.8884 16.6956 30.3627 18.7601 30.3627 20.8583C30.3627 22.1105 30.9175 22.9565 31.715 23.6334C31.2642 23.9718 29.6692 25.2917 29.6692 27.153C29.6692 29.4543 31.5763 31.6541 35.1824 31.6541C38.8579 31.6541 40.6957 29.4543 40.6957 27.2207C40.6957 25.8332 39.9328 24.8856 38.9273 24.2087ZM35.1822 28.5739C34.1767 28.5739 33.3792 27.8294 33.3792 26.8818C33.3792 26.1034 33.8299 25.4942 34.1767 25.122C34.2903 25.1721 34.4032 25.2215 34.5146 25.2703C35.8305 25.846 36.9506 26.3361 36.9506 27.0848C36.9506 28.0663 36.2918 28.5739 35.1822 28.5739ZM36.8469 21.1965C36.8469 20.3843 36.2574 19.8428 35.2865 19.8428C34.3503 19.8428 33.9342 20.3504 33.9342 20.9934C33.9342 21.941 35.0091 22.4487 36.3268 22.9901C36.4655 22.7532 36.8469 22.0764 36.8469 21.1965Z"
        fill={theme.brand01}
      />
    </svg>
    /* eslint-enable */
  );
};

export const LogoLink = ({ isCompact }) => (
  <Container>
    <Logo />
    {!isCompact && (
      <div>
        <h6>Productivity Workspace</h6>
      </div>
    )}
  </Container>
);
